import DOMPurify from 'dompurify';

/**
 * Sanitiza contenido HTML para prevenir ataques XSS
 * @param content Contenido a sanitizar
 * @returns Contenido sanitizado
 */
export const sanitizeContent = (content: string): string => {
  return DOMPurify.sanitize(content, {
    ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'a', 'p', 'br'],
    ALLOWED_ATTR: ['href', 'target', 'rel'],
  });
};

/**
 * Sanitiza texto plano (elimina cualquier HTML)
 * @param text Texto a sanitizar
 * @returns Texto sanitizado
 */
export const sanitizeText = (text: string): string => {
  return DOMPurify.sanitize(text, { ALLOWED_TAGS: [] });
};

/**
 * Sanitiza y formatea texto con enlaces para hashtags y menciones
 * @param text Texto a procesar
 * @returns HTML sanitizado con enlaces
 */
export const formatTextWithLinks = (text: string): string => {
  // Primero sanitizamos el texto para eliminar cualquier HTML malicioso
  const sanitizedText = sanitizeText(text);
  
  // Luego reemplazamos URLs, hashtags y menciones con enlaces
  const linkedText = sanitizedText
    // URLs
    .replace(
      /(https?:\/\/[^\s]+)/g, 
      '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>'
    )
    // Hashtags
    .replace(
      /#(\w+)/g, 
      '<a href="/search?q=%23$1" class="text-domired-600 hover:underline">#$1</a>'
    )
    // Menciones
    .replace(
      /@(\w+)/g, 
      '<a href="/search?q=@$1" class="text-domired-600 hover:underline">@$1</a>'
    );
  
  // Finalmente sanitizamos el resultado para asegurar que solo contiene los enlaces que acabamos de crear
  return DOMPurify.sanitize(linkedText, {
    ALLOWED_TAGS: ['a'],
    ALLOWED_ATTR: ['href', 'target', 'rel', 'class'],
  });
};
